
import {
  MDBSpinner
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect } from 'react';
import { CartContext } from './context/CartProvider';
import { GeographyContext } from "./context/GeographyProvider";
import { MiscContext } from "./context/MiscProvider";
import { NavbarContext } from './context/NavProvider';
import { UserProfileContext } from './context/UserProfileProvider';
import HomeContent from './HomeContent';
import Testimonials from './testimonials/Testimonials';
import { fetchCart, fetchMainPageData, fetchUserProfile } from './utils/Common';

const Home = ({ openLoginModal, openNavbar }) => {

  const {ipAddress} = useContext(GeographyContext);
  const {setIsPricing,setBusiness,pageData,setPageData} = useContext(NavbarContext);
  const { setCartCount, setCartId, cartId} = useContext(CartContext);
  const {setUid,setAddresses,setPhones,setEmails,setUserProfile,tokenLoaded,setGroups} = useContext(UserProfileContext);
 
  const { testimonials } = useContext(MiscContext);

 
 useEffect(() => {    
        fetchMainPageData(setPageData, setIsPricing,pageData,setBusiness);
   }, [pageData, setIsPricing, setPageData, tokenLoaded,setBusiness]); 
  
   
  useEffect(() => {
   
  fetchUserProfile(setUserProfile, setUid, setAddresses, setEmails, setPhones, tokenLoaded,setGroups);

  }, [setAddresses, setEmails, setGroups, setPhones, setUid, setUserProfile, tokenLoaded]);


  const fetchItems = useCallback(async (domainIdf) => {
    fetchCart(cartId, setCartCount, setCartId, tokenLoaded,ipAddress);
  
  }, []);


  useEffect(() => {
    fetchItems();  
  }, [fetchItems]);





  return ( 
  <section  className="mb-2 position-relative  justify-content-center text-center">
      { 
        (!pageData) ? 
        (
          <MDBSpinner className='m-5'>
            <span className='visually-hidden'>Loading...</span>
          </MDBSpinner>
        ) : (
          <HomeContent/>
        )
      }
    
    {testimonials &&  <Testimonials/>}

   </section>
  

   
  );
  
};

Home.propTypes = {
 
  openLoginModal: PropTypes.func,
  openNavbar: PropTypes.func
};


export default Home;
